export default __webpack_public_path__ + "media/images/features/saga/map-11bd8f375f6d6efbbfe013d55bfac845.png";